import {EntityType} from '../document';

export interface GetParams {
  startRow: number;
  endRow: number;
  sortDirection: 'asc' | 'desc';
  sortProperty: string;
  filterProperty?: string;
  filterValue?: string;

  // Parametros del GET de Documents
  entityId?: number;
  companyId?: number;
  entityType?: EntityType;
}

export interface GetAdvancedParams {
  startRow: number;
  endRow: number;
  sortDirection: 'asc' | 'desc';
  sortProperty: string;
  filterGroups?: FilterGroup[][];
  includes?: Array<string | number>;
  includeDescription?: boolean;
}

export interface FilterGroup {
  property: string;
  // Puede ser un valor simple o una lista (para operadores como 'In')
  value:
    | string
    | number
    | boolean
    | null
    | Array<string | number | boolean | null>;
  // operatorValue?: number
  operator: AdvancedFilterOperators;
  collectionGroup?: string;
}

export type AdvancedFilterOperators =
  'Contains' // Text contains value (LIKE %value%)
  | 'StartsWith' // Text starts with value (LIKE value%)
  | 'EndsWith' // Text ends with value (LIKE %value)
  | 'Equals' // Exact match (==)
  | 'NotEquals'
  | 'In' // Value is in list (provide array as value)
  | 'LessThan' // Less than or equal to (<=)
  | 'LessThanOrEqual' // Less than (<)
  | 'GreaterThan' // Greater than (>)
  | 'GreaterThanOrEqual'; // Greater than or equal to (>=)


